import React from "react";
import { ArrowRight } from "lucide-react";
import { STEPS } from "../mock";

const HowItWorks = () => {
  return (
    <section className="py-20 md:py-28 px-5 md:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="text-center max-w-2xl mx-auto fade-up">
          <div className="flex items-center justify-center gap-2 mb-4">
            <span className="h-px w-6 bg-[#159A90]" />
            <span className="text-[12px] font-bold tracking-[0.16em] text-[#159A90] uppercase">
              How It Works
            </span>
            <span className="h-px w-6 bg-[#159A90]" />
          </div>
          <h2 className="font-heading font-extrabold text-[#1B2A4A] text-[32px] md:text-[42px] leading-tight">
            Finding the right caregiver is simple, quick and reassuring
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mt-14 relative">
          {STEPS.map((s, i) => (
            <div
              key={s.num}
              className="relative bg-white rounded-[24px] p-8 border border-[#DEE6EE] shadow-[0_8px_24px_rgba(0,0,0,0.04)] hover:shadow-[0_18px_45px_rgba(0,0,0,0.1)] hover:-translate-y-1 transition-all fade-up"
              style={{ transitionDelay: `${i * 90}ms` }}
            >
              <div className="flex items-center justify-center w-14 h-14 rounded-2xl bg-[#1B2A4A] text-[#8FD1CB] font-heading font-extrabold text-[20px]">
                {s.num}
              </div>
              <h3 className="font-heading font-bold text-[19px] text-[#1B2A4A] mt-5">
                {s.title}
              </h3>
              <p className="text-[14.5px] text-[#6b7481] mt-2.5 leading-relaxed">
                {s.desc}
              </p>
            </div>
          ))}
        </div>

        <div className="flex justify-center mt-12 fade-up">
          <a
            href="#book"
            className="flex items-center gap-2 px-8 py-3.5 rounded-full bg-[#159A90] text-white font-semibold hover:bg-[#0E7A72] transition-colors shadow-[0_10px_30px_rgba(21,154,144,0.35)]"
          >
            Get Started <ArrowRight size={18} />
          </a>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
